import { PREDICATE_OPERATORS } from '../../constants';
// Guards
export var isPredicateOperator = function isPredicateOperator(operator) {
  return PREDICATE_OPERATORS.includes(operator);
};